import { render } from "./PaymentsView.vue?vue&type=template&id=d8e48bce"
import script from "./PaymentsView.vue?vue&type=script&lang=js"
export * from "./PaymentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__